// These values are intentionally enabled only through .env.local for local
// testing. Never set either flag in a public/production deployment.
export const LOCAL_AUTH_BYPASS =
  process.env.NEXT_PUBLIC_LOCAL_AUTH_BYPASS === 'true' ||
  process.env.LOCAL_AUTH_BYPASS === 'true';

export const LOCAL_WIKI_TOKEN = 'local-development-session';

export const LOCAL_WIKI_USER = {
  uid: 0,
  name: '本地测试用户',
  method: 'nickname' as const,
  avatar: '',
  description: '本地开发测试账号',
};

export const LOCAL_AUTH_USER = {
  uid: 0,
  username: LOCAL_WIKI_USER.name,
  email: 'local-user@wiki.test',
};
